module.exports = __webpack_public_path__ + "img/31.7.Chla.61868c13.png";